import { css } from 'styled-components';
export const SitePadding = 24;
export const SiteWidth = 1504;
export const SiteWidthBreakpoint = SiteWidth + SitePadding * 2;
export const siteWide = css `
  margin: 0 auto;
  max-width: calc(var(--siteWidth) + var(--sitePadding) + var(--sitePadding));
  padding: 0 var(--sitePadding);
  width: 100%;
`;
export const baseGrid = css `
  display: grid;
  column-gap: var(--gutterWidth);
  grid-template-columns: repeat(12, 1fr);
`;
